import { createContext, useContext, useState } from "react";

const ScriptPanelContext = createContext(null);

export function ScriptPanelProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [activeLead, setActiveLead] = useState(null);
  const [defaultTab, setDefaultTab] = useState("funding_call");

  const openScriptPanel = (lead, category) => {
    setActiveLead(lead || null);
    setDefaultTab(category === "trust" ? "trust_call" : "funding_call");
    setOpen(true);
  };

  return (
    <ScriptPanelContext.Provider value={{ open, setOpen, activeLead, defaultTab, openScriptPanel }}>
      {children}
    </ScriptPanelContext.Provider>
  );
}

export const useScriptPanel = () => useContext(ScriptPanelContext);
